import React, { useState, useEffect } from "react";
import "../refinance/remaining-balance.css";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const BuildDownPayment = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);
  const [priceInputValue, setpriceInputValue] = useState(0);
  const [downPaymentAmount, setdownPaymentAmount] = useState(0);
  const [priceInput] = useState({
    0: 0,
    1: 0.03,
    2: 0.05,
    3: 0.1,
    4: 0.15,
    5: 0.2,
    6: 0.25,
    7: 0.3,
    8: 0.35,
    9: 0.4,
    10: 0.45,
    11: 0.5,
    12: 0.5503,
    13: 0.6,
    14: 0.65,
    15: 0.7,
    16: 0.75,
    17: 0.8,
    18: 0.85,
    19: 0.9,
  });
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const checkForNextStep = () => {
    if (formData.downPayment === 0) {
      return setError(true);
    }
    if (formData.downPayment !== "") {
      formData.downPayment = downPaymentAmount;
      setError(false);
      navigation.next();
      // console.log("next");
    }
  };

  // console.log(formData.remainingBalance);

  const slider = React.createRef();
  const sliderValue = React.createRef();
  //   console.log(priceInput[priceInputValue]);
  useEffect(() => {
    slider.current.setAttribute("min", 0);
    slider.current.setAttribute("max", Object.keys(priceInput).length - 1);
    const thumbSize = parseInt(window.getComputedStyle(sliderValue.current).getPropertyValue("--thumb-size"), 10);
    handleSliderValuePosition(slider.current, thumbSize);
  }, [priceInputValue]);

  const handlePricingSlide = (e) => {
    setpriceInputValue(e.target.value);
    handleSliderValuePosition(e.target);
  };

  useEffect(() => {
    formData.downPayment = downPaymentAmount;
    // console.log(formData.purchasePrice);
    createDownPaymentAmount(formData.projectBudget, priceInput[priceInputValue]);
  }, [priceInputValue]);

  const handleSliderValuePosition = (input, thumbSize) => {
    const multiplier = input.value / input.max;
    const thumbOffset = thumbSize * multiplier;
    const priceInputOffset = (thumbSize - sliderValue.current.clientWidth) / 2;
    sliderValue.current.style.left = input.clientWidth * multiplier - thumbOffset + priceInputOffset + "px";
  };

  const createDownPaymentAmount = (purchasePriceAmount, decimal) => {
    const purchasePrice = stringToNumber(purchasePriceAmount);
    const downPayment = purchasePrice * decimal;
    setdownPaymentAmount(downPayment);
  };

  const stringToNumber = (string) => {
    return parseInt(string.replace(/[^0-9]/g, ""));
  };

  const addCommas = (number) => {
    let wholeNum = number.toFixed(0);
    return wholeNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className={stepStyles.page}>
      <div className="w-full">
        <ProgressBar width={"70%"} />
        <div className={stepStyles.content}>
          {transition((style, item) =>
            item ? (
              <animated.div style={style} className={stepStyles.panel}>
                <h1 className={stepStyles.title}>What is the estimated down payment?</h1>
                <div className="pricing">
                  <div className="pricing-slider center-content">
                    <label className="form-slider">
                      <input
                        type="range"
                        ref={slider}
                        defaultValue={priceInputValue}
                        onChange={handlePricingSlide}
                        name="homeValue"
                      />
                    </label>
                  </div>
                  <div ref={sliderValue} className="pricing-slider-value space-y-4">
                    <h2 className={stepStyles.sliderSubValue}>{(priceInput[priceInputValue] * 100).toFixed(0)}%</h2>
                    <h2 className={stepStyles.sliderValue}>${addCommas(downPaymentAmount)}</h2>
                  </div>
                </div>
                {error ? <div className={stepStyles.sliderError}>Please select a down payment amount</div> : null}
              </animated.div>
            ) : null,
          )}
        </div>
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildDownPayment;
